app.controller('baseOfCaseSearchController', ['$rootScope', '$scope', '$state', '$stateParams', '$mdDialog', '$mdToast', '$translate', 'objectHelper', 'baseModel', 'applicationModel', 'patientModel', 'visitModel', 'baseOfCaseModel',
    function ($rootScope, $scope, $state, $stateParams, $mdDialog, $mdToast, $translate, objectHelper, baseModel, applicationModel, patientModel, visitModel, baseOfCaseModel) {
        "use strict";

        function addNewDiagnosisToList(icd10) {
            if (!_.includes($scope.searchCriteria.idsIcd10, icd10.id)) {
                if (!_.isArray($scope.searchCriteria.idsIcd10)) { $scope.searchCriteria.idsIcd10 = []; }
                $scope.searchCriteria.idsIcd10.push(icd10.id);
                if (!_.includes($scope.selectedCriteriaList.diagnosis, {id: icd10.id})) {
                    $scope.selectedCriteriaList.diagnosis.push(icd10);
                }
                baseOfCaseModel.selectedCriteriaList = $scope.selectedCriteriaList;
                baseOfCaseModel.searchCriteria = $scope.searchCriteria;
            }
            //$scope.selectedCriteriaList.diagnosis = null;

        }

        function addNewProcedureToList(icd9) {
            if (!_.includes($scope.searchCriteria.idsIcd9, icd9.id)) {
                if (!_.isArray($scope.searchCriteria.idsIcd9)) { $scope.searchCriteria.idsIcd9 = []; }
                $scope.searchCriteria.idsIcd9.push(icd9.id);
                if (!_.includes($scope.selectedCriteriaList.procedure, {id: icd9.id})) {
                    $scope.selectedCriteriaList.procedure.push(icd9);
                }
                baseOfCaseModel.selectedCriteriaList = $scope.selectedCriteriaList;
                baseOfCaseModel.searchCriteria = $scope.searchCriteria;
            }

            //$scope.selectedCriteriaList.procedure = null;
        }

        function addNewClassificationToList(icf) {
            if (!_.includes($scope.searchCriteria.idsIcf, icf.id)) {
                if (!_.isArray($scope.searchCriteria.idsIcf)) { $scope.searchCriteria.idsIcf = []; }
                $scope.searchCriteria.idsIcf.push(icf.id);
                if (!_.includes($scope.selectedCriteriaList.classification, {id: icf.id})) {
                    $scope.selectedCriteriaList.classification.push(icf);
                }
                baseOfCaseModel.selectedCriteriaList = $scope.selectedCriteriaList;
                baseOfCaseModel.searchCriteria = $scope.searchCriteria;
            }
            //$scope.selectedCriteriaList.classification = null;
        }

        function setData() {
            $scope.forms = {
                searchBaseOfCaseForm: {}
            };

            $scope.vm = {
                icd10NewField: null,
                icd9NewField: null,
                classification: null
            };
            $scope.maxPatientAge = _.range(100);

            $scope.showColumn = objectHelper.createObject(BaseOfCaseShowColumn, {
                reconnaissance: true,
                physicalExamination: false,
                mainDiagnosis: true,
                recommendations: false,
                drugList: true,
                documentList: true,
                icfClassifications: true,
                icd9Procedure: true
            });

            $scope.gridColumns = [];

            $scope.searchResultData = [];

            $scope.selectedCriteriaList = baseOfCaseModel.selectedCriteriaList;

            if (!$scope.selectedCriteriaList) {
                $scope.selectedCriteriaList = {
                    diagnosis: [],
                    procedure: [],
                    classification: []
                };
                baseOfCaseModel.selectedCriteriaList = $scope.selectedCriteriaList;
            }

            $scope.searchCriteria = baseOfCaseModel.searchCriteria;

            if (!$scope.searchCriteria) {
                $scope.searchCriteria = objectHelper.createObject(VisitCardCriteria, {
                    idsIcd10: [],
                    rowsPerSheet: 20,
                    idsIcd9: [],
                    idsIcf: [],
                    ageFrom: null,
                    ageTo: null
                });
                baseOfCaseModel.searchCriteria = $scope.searchCriteria;
            }

            $scope.searchResultView = baseOfCaseModel.searchResultView;
            $scope.enableSearchButton = false;

            $scope.genderList = [
                {
                    value: Enum.GENDER.FEMALE,
                    label: 'T.ENUM.GENDER.FEMALE'
                },
                {
                    value: Enum.GENDER.MALE,
                    label: 'T.ENUM.GENDER.MALE'
                }
            ]
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$watch('showColumn', function(newVal) {
                $scope.setColumns();
            }, true);

            $scope.$watch('vm.icd10NewField', function(newVal, oldVal) {
                if(!_.isUndefined(newVal) && newVal != null) {
                    addNewDiagnosisToList(newVal);
                    $scope.vm.icd10NewField = undefined;
                }
            });

            $scope.$watch('vm.icd9NewField', function(newVal, oldVal) {
                if(!_.isUndefined(newVal) && newVal != null) {
                    addNewProcedureToList(newVal);
                    $scope.vm.icd9NewField = undefined;
                }
            });

            $scope.$watch('vm.icfNewField', function(newVal, oldVal) {
                if(!_.isUndefined(newVal) && newVal != null) {
                    addNewClassificationToList(newVal);
                    $scope.vm.icfNewField = undefined;
                }
            });

            $scope.$watch('searchCriteria', function (criteria) {
                var foundNotEmptyField = false;
                _.each(criteria, function (value, key) {
                   if (key == 'idsIcd9' || key == 'idsIcd10'  || key == 'idsIcf' || key == 'gender' || key == 'ageFrom' || key == 'ageTo') {
                       if (value) {
                           if (value.length > 0 || criteria['ageFrom'] != null || criteria['ageTo'] != null) {
                               foundNotEmptyField = true;
                           }
                       }
                   }
                });

                $scope.enableSearchButton = foundNotEmptyField;
            }, true);

            $scope.$on(Event.BASE_OF_CASE.GET_ANONYMIZED_DATA.SUCCESS, function(event, result) {
                $scope.searchResultData = result;
            });

        }

        function setActions() {

            $scope.search = function () {
                $scope.searchCriteria.pageNumber = 0;
                if ($scope.searchCriteria.gender == '') {
                    $scope.searchCriteria.gender = null;
                }
                $scope.searchCriteria.ageFrom = parseInt($scope.searchCriteria.ageFrom);
                $scope.searchCriteria.ageTo = parseInt($scope.searchCriteria.ageTo);
                baseOfCaseModel.getAnonymizedData($scope.searchCriteria);
                $scope.searchResultView = true;
                $scope.setColumns();
                baseOfCaseModel.searchResultView = $scope.searchResultView;

            };

            $scope.clearSearch = function () {
                $scope.searchResultView = false;
                baseOfCaseModel.searchResultView = $scope.searchResultView;

                $scope.selectedCriteriaList = {
                    diagnosis: [],
                    procedure: [],
                    classification: []
                };

                $scope.searchCriteria = objectHelper.createObject(VisitCardCriteria, {
                    idsIcd10: [],
                    rowsPerSheet: 20,
                    idsIcd9: [],
                    idsIcf: [],
                    ageFrom: null,
                    ageTo: null
                });

                baseOfCaseModel.selectedCriteriaList = $scope.selectedCriteriaList;
                baseOfCaseModel.searchCriteria = $scope.searchCriteria;

            };

            $scope.changeSearchCriteria = function () {
                $scope.searchResultView = false;
            };

            $scope.criteriaChanged = function () {
                if ($scope.searchCriteria.gender == '') {
                    $scope.searchCriteria.gender = null;
                }
                $scope.searchCriteria.ageFrom = parseInt($scope.searchCriteria.ageFrom);
                $scope.searchCriteria.ageTo = parseInt($scope.searchCriteria.ageTo);
                baseOfCaseModel.getAnonymizedData($scope.searchCriteria);
                $scope.searchResultView = true;
                $scope.setColumns();
                baseOfCaseModel.searchResultView = $scope.searchResultView;
            };

            $scope.removeIcd10Entry = function(diagnosis) {
                $scope.searchCriteria.idsIcd10 = _.remove($scope.searchCriteria.idsIcd10, diagnosis.id);
                $scope.selectedCriteriaList.diagnosis = _.reject($scope.selectedCriteriaList.diagnosis, {id: diagnosis.id});
            };

            $scope.removeIcd9Entry = function(diagnosis) {
                $scope.searchCriteria.idsIcd9 = _.remove($scope.searchCriteria.idsIcd9, diagnosis.id);
                $scope.selectedCriteriaList.procedure = _.reject($scope.selectedCriteriaList.procedure, {id: diagnosis.id});
            };

            $scope.removeIcfEntry = function(diagnosis) {
                $scope.searchCriteria.idsIcf = _.remove($scope.searchCriteria.idsIcf, diagnosis.id);
                $scope.selectedCriteriaList.classification = _.reject($scope.selectedCriteriaList.classification, {id: diagnosis.id});
            };

            $scope.openReconnaissancePopup = function (item) {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/baseOfCase/popup/base-of-case-reconnaissance-popup.html',
                    controller: 'popupBaseOfCaseReconnaissanceController',
                    resolve: {
                        item: function() {
                            return item;
                        }
                    }
                }).then(function(result) {
                    if (result.action == 'openVisitCard') {
                        $state.go(Constant.STATE.APP.BASE_OF_CASE.VISIT_CARD, {idVisitCard: result.item.id});
                    }
                    if (result.action == 'openStateOfHealth') {
                        $state.go(Constant.STATE.APP.BASE_OF_CASE.STATE_OF_HEALTH, {idVisitCard: result.item.id});
                    }
                    if (result.action == 'openVisitHistory') {
                        $state.go(Constant.STATE.APP.BASE_OF_CASE.VISIT_HISTORY, {idVisitCard: result.item.id});
                    }
                }, function(error){

                })
            };

            $scope.setColumns = function () {
                $scope.gridColumns = [];
                if ($scope.showColumn.reconnaissance) {
                    $scope.gridColumns.push(
                        {
                            cellTemplate: 'edm/application/view/app/baseOfCase/grid-template/data-grid-base-of-case-reconnaissance-row-template.html',
                            displayName: $translate.instant('T.MODULE.BASE_OF_CASE.RECONNAISSANCE')
                        }
                    )
                }

                if ($scope.showColumn.physicalExamination) {
                    $scope.gridColumns.push(
                        {
                            field: "physicalExamination",
                            displayName: $translate.instant('T.MODULE.BASE_OF_CASE.PHYSICAL_EXAMINATION')
                        }
                    )
                }

                if ($scope.showColumn.mainDiagnosis) {
                    $scope.gridColumns.push(
                        {
                            cellTemplate: 'edm/application/view/app/baseOfCase/grid-template/data-grid-base-of-case-main-diagnosis-row-template.html',
                            displayName: $translate.instant('T.MODULE.BASE_OF_CASE.MAIN_DIAGNOSIS')
                        }
                    )
                }

                if ($scope.showColumn.recommendations) {
                    $scope.gridColumns.push(
                        {
                            field: "recommendations",
                            displayName: $translate.instant('T.MODULE.BASE_OF_CASE.DOCTOR_ORDERS')
                        }
                    )
                }

                if ($scope.showColumn.drugList) {
                    $scope.gridColumns.push(
                        {
                            cellTemplate: 'edm/application/view/app/baseOfCase/grid-template/data-grid-base-of-case-drug-list-row-template.html',
                            displayName: $translate.instant('T.MODULE.BASE_OF_CASE.DRUGS')
                        }
                    )
                }

                if ($scope.showColumn.documentList) {
                    $scope.gridColumns.push(
                        {
                            cellTemplate: 'edm/application/view/app/baseOfCase/grid-template/data-grid-base-of-case-document-list-row-template.html',
                            displayName: $translate.instant('T.MODULE.BASE_OF_CASE.DOCUMENT_LIST')
                        }
                    )
                }

                if ($scope.showColumn.icfClassifications) {
                    $scope.gridColumns.push(
                        {
                            cellTemplate: 'edm/application/view/app/baseOfCase/grid-template/data-grid-base-of-case-icf-classification-row-template.html',
                            displayName: $translate.instant('T.MODULE.BASE_OF_CASE.ICF_CLASSIFICATION')
                        }
                    )
                }

                if ($scope.showColumn.icd9Procedure) {
                    //medicalProcedures
                    $scope.gridColumns.push(
                        {
                            cellTemplate: 'edm/application/view/app/baseOfCase/grid-template/data-grid-base-of-case-icd9-procedure-row-template.html',
                            displayName: $translate.instant('T.MODULE.BASE_OF_CASE.ICD9_PROCEDURE')
                        }
                    )
                }
            };
        }

        function configureInterface() {

        }

        function initialize() {
            if ($scope.searchResultView) {
                $scope.search();
            }
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
